import request from '../utils/request'


export function index(params) {
    return request({
        url: '/doctorProcessReport',
        method: 'get',
        params
    })
}

export function show(id) {
    return request({
        url: `/doctorProcessReport/${id}`,
        method: 'get'
    })
}

export function store(data) {
    return request({
        url: '/doctorProcessReport',
        method: 'post',
        data
    })
}

export function update(data) {
    return request({
        url: `/doctorProcessReport/${data.id}`,
        method: 'put',
        data
    })
}

export function destroy(id) {
    return request({
        url: `/doctorProcessReport/${id}`,
        method: 'delete',
    })
}